// extracted by mini-css-extract-plugin
export default {"wrap":"modal_wrap__2mf4+","modal":"modal_modal__VfNLv","content":"modal_content__9L2sl","close":"modal_close__rbr+u"};